import { render } from "./CreateItem.vue?vue&type=template&id=37b8709e&scoped=true"
import script from "./CreateItem.vue?vue&type=script&lang=ts"
export * from "./CreateItem.vue?vue&type=script&lang=ts"

import "./CreateItem.vue?vue&type=style&index=0&id=37b8709e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-37b8709e"

export default script